import React from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import CheckBox from "../../PageLayout/CheckBox";
import {AVAILABLE_VISUALIZERS} from "../../../constants/dashboard";
import {getFeatureEditPermission} from "../featuresFunctions";
import {featureInterface} from "../FeaturesSetupFeature/featureInterface";
import {AccessRights} from "../../../schemas/accessRightsModel";

const FeaturesSetupTogglePopupTable = (props) => {

  const {subscriptions, popupFeature, setPopupFeature, enablePermission} = props;

  if (!popupFeature) {
    return null
  }

  if (!subscriptions.length) {
    return (
      <p className="fs-toggle-popup__table text-center">
        <FormattedMessage id="wizard.noFabricatorSubscriptions"/>
      </p>
    )
  }

  const onChecked = (subscription, property) => {
    if (!popupFeature.toolSettings.some(subscr => subscr.tool === subscription)) {
      // create toolSetting object if it is missing!
      popupFeature.toolSettings.push({tool: subscription});
    }
    setPopupFeature(Object.assign({}, popupFeature, {
      toolSettings: popupFeature.toolSettings.map(subscr => {
        if (subscr.tool === subscription) {
          return Object.assign({}, subscr, {[property]: !subscr[property]})
        }
        return subscr
      })
    }))
  }

  console.log("popupFeature", popupFeature);

  return (
    <div className="fs-toggle-popup__table">
      <div className="fs-toggle-popup__table-row">
        <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--name"/>
        <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--checkbox">
          <span className="generic-popup-title">
            <FormattedMessage id="features.setup.togglePopup.visualizer"/>
          </span>
        </div>
        <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--checkbox">
          <span className="generic-popup-title">
            <FormattedMessage id="features.setup.togglePopup.quoting"/>
          </span>
        </div>
      </div>
      {subscriptions.map(subscription => {
        return (
          <div className="fs-toggle-popup__table-row bordered" key={subscription}>
            <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--name">
              <FormattedMessage id={"wizard.subscription." + subscription}/>
            </div>
            {["visualizer", "quoting"].map((view) => {
              const property = view === "visualizer" ? "enableVisualizer" : "enableQuotingTool";
              const toolSettingsObject = popupFeature.toolSettings
                ? popupFeature.toolSettings.find(setting => setting.tool === subscription)
                : null;
              return (
                <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--checkbox" key={view}>
                  {property && enablePermission.visible ? (
                    <CheckBox checked={toolSettingsObject && toolSettingsObject[property]}
                              innerStyle="none"
                              type={"medium"}
                              disabled={!enablePermission.enabled}
                              onChecked={() => onChecked(subscription, property)}
                              text=""/>
                  ) : null}
                </div>
              )
            })}
          </div>
        )
      })}
    </div>
  )
};

FeaturesSetupTogglePopupTable.propTypes = {
  popupFeature: PropTypes.shape(featureInterface).isRequired,
  setPopupFeature: PropTypes.func.isRequired
}

const mapStateToProps = (store) => {
  const {hasKitchenSub, hasBathroomSub, hasFireplaceSub, hasLaundryRoomSub, hasLeadFormSub} = store.auth;
  const {enablePermission} = getFeatureEditPermission(store);
  const AR = AccessRights.get(store);

  let subscriptions = [];
  if (hasBathroomSub || AR.isSiteAdmin(false)) {
    subscriptions.push(AVAILABLE_VISUALIZERS.bathroom)
  }
  if (hasKitchenSub || AR.isSiteAdmin(false)) {
    subscriptions.push(AVAILABLE_VISUALIZERS.kitchen)
  }
  if (hasFireplaceSub || AR.isSiteAdmin(false)) {
    subscriptions.push(AVAILABLE_VISUALIZERS.fireplace)
  }
  if (hasLaundryRoomSub || AR.isSiteAdmin(false)) {
    subscriptions.push(AVAILABLE_VISUALIZERS.laundryroom)
  }
  if (hasLeadFormSub || AR.isSiteAdmin(false)) {
    subscriptions.push(AVAILABLE_VISUALIZERS.leadform)
  }

  return {
    subscriptions,
    enablePermission,
  };
};

const mapDispatchToProps = {
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupTogglePopupTable)
)
